var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTagCircle = function SvgTagCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TagCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TagCircle_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TagCircle_svg__c)",
    fill: "#5C7AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.999 12.655-.127-4.588a.967.967 0 0 0-.94-.94L15.344 7a.96.96 0 0 0-.71.283l-7.351 7.351a.968.968 0 0 0 0 1.368l4.715 4.715a.967.967 0 0 0 1.367 0l7.351-7.351a.971.971 0 0 0 .283-.71Zm-.954.04-7.35 7.35a.017.017 0 0 1-.014.006.017.017 0 0 1-.013-.005L7.954 15.33a.018.018 0 0 1 0-.026l7.35-7.35a.019.019 0 0 1 .014-.006l4.588.126c.01 0 .018.009.018.018l.127 4.588c0 .006-.002.01-.006.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.573 9.101a1.644 1.644 0 1 0 2.326 0 1.644 1.644 0 0 0-2.326 0Zm1.654 1.655a.695.695 0 1 1-.983-.983.695.695 0 0 1 .983.983Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TagCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "TagCircle_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "TagCircle_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgTagCircle;